import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/team/$teamId/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/(dashboard)/_authenticated/$companyId/$teamId/"!</div>;
}
